import { useMemo } from 'react';
import { useLocales } from 'src/components/utils/locales';
import SvgColor from 'src/components/ui/SvgColor';

// ----------------------------------------------------------------------

const icon = (name) => (
  <SvgColor src={`/assets/icons/navbar/${name}.svg`} sx={{ width: 1, height: 1 }} />
);

const ICONS = {
  job: icon('ic_job'),
  blog: icon('ic_blog'),
  chat: icon('ic_chat'),
  mail: icon('ic_mail'),
  user: icon('ic_user'),
  file: icon('ic_file'),
  lock: icon('ic_lock'),
  tour: icon('ic_tour'),
  order: icon('ic_order'),
  label: icon('ic_label'),
  blank: icon('ic_blank'),
  kanban: icon('ic_kanban'),
  folder: icon('ic_folder'),
  banking: icon('ic_banking'),
  booking: icon('ic_booking'),
  invoice: icon('ic_invoice'),
  product: icon('ic_product'),
  calendar: icon('ic_calendar'),
  disabled: icon('ic_disabled'),
  external: icon('ic_external'),
  menuItem: icon('ic_menu_item'),
  ecommerce: icon('ic_ecommerce'),
  analytics: icon('ic_analytics'),
  dashboard: icon('ic_dashboard'),
};

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      {
        subheader: t('Request Management'),
        items: [
          {
            title: t('Requests'),
            path: '/requests',
            icon: ICONS.user,
          },
        ],
      },
      {
        subheader: t('Inventory'),
        items: [
          {
            title: t('Inventory Settings'),
            path: '/inventory',
            icon: ICONS.user,
          },
          {
            title: t('Inventory Content'),
            path: '/content',
            icon: ICONS.user,
          },
        ],
      },
    ],
    [t]
  );

  return data;
}
